import * as _ from 'lodash';
import { create } from 'zustand';
import { DateService } from '../services/DateService';
import { immerMiddleware } from '../services/Utils';
import { POST_PRIVACY } from '../types/postsTypings';

export const defaultForm = {
  title: '',
  image: '',
  details: '',
  startDate: '',
  endDate: '',
  privacy: POST_PRIVACY.PRIVATE,
  tags: [],
  fields: []
};

export const defaultFormData = {
  startTime: DateService.getCurrentDate(),
  endTime: DateService.getCurrentDate(),
  data: {}
};

const formsStore = set => ({
  form: defaultForm,
  data: defaultFormData,
  setData: (key: string, value: string) => {
    set(state => {
      state.data.data[key] = value;
    });
  },
  setDataFull: data => {
    set(state => {
      state.data = data;
    });
  },
  setDataStartTime: startTime => {
    set(state => {
      state.data.startTime = startTime;
    });
  },
  setDataEndTime: endTime => {
    set(state => {
      state.data.endTime = endTime;
    });
  },
  setForm: form => {
    set(state => {
      state.form = form;
    });
  },
  setId: id => {
    set(state => {
      state.form.id = id;
    });
  },
  setTitle: title => {
    set(state => {
      state.form.title = title;
    });
  },
  setImage: image => {
    set(state => {
      state.form.image = image;
    });
  },
  setStartDate: startDate => {
    set(state => {
      state.form.startDate = startDate;
    });
  },
  setEndDate: endDate => {
    set(state => {
      state.form.endDate = endDate;
    });
  },
  setDetails: details => {
    set(state => {
      state.form.details = details;
    });
  },
  setPrivacy: privacy => {
    set(state => {
      state.form.privacy = privacy;
      if (privacy === 'PUBLIC') {
        state.form.users = [];
      }
    });
  },
  setUsers: users => {
    set(state => {
      state.form.users = users;
    });
  },
  setTags: tags => {
    set(state => {
      state.form.tags = tags;
    });
  },
  moveField: (dragIndex: number, hoverIndex: number) => {
    set(state => {
      const fields = state.form.fields;
      const newFields = _.cloneDeep(fields);
      newFields.splice(dragIndex, 1);
      newFields.splice(hoverIndex, 0, fields[dragIndex]);
      state.form.fields = newFields;
    });
  },
  addField: field => {
    set(state => {
      state.form.fields.push(field);
    });
  },
  updateField: (field, index) => {
    set(state => {
      state.form.fields.splice(index, 1, field);
    });
  },
  deleteField: index => {
    set(state => {
      state.form.fields.splice(index, 1);
    });
  }
});

export const useFormsStore = create(immerMiddleware(formsStore));
